var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxTaped = function SvgBoxTaped(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.178 8.4 6.78 4.8h3.495L9.6 8.4H5.178M9 9.6h.6v3.6h4.8V9.6h4.8v9.6H4.8V9.6zm1.8 0h2.4V12h-2.4zm3.6-1.2-.675-3.6h3.495l1.6 3.6H14.4m-1.223 0h-2.359l.675-3.6h1.01zm.323-4.8H6L3.6 9v11.4h16.8V9L18 3.6z"
  })));
};
export default SvgBoxTaped;